import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  contactDetailsHeading: {
    id: "funding-application: contact details heading",
    defaultMessage: "Contact details",
  },
  phoneNumberLabel: {
    id: "funding-application: contact details phone number label",
    defaultMessage: "Phone number (optional)",
  },
  phoneNumberHelperText: {
    id: "funding-application: contact details phone number helper text",
    defaultMessage: "We'll use this to share updates on your application",
  },
  websiteFieldLabel: {
    id: "funding-application: website field label",
    defaultMessage: "What’s the website address (URL) you sell from? (optional)",
  },
  websiteFieldHelperText: {
    id: "funding-application: website field helper text",
    defaultMessage: "Please add all that apply",
  },
  addAnotherWebsiteLabel: {
    id: "funding-application: website add field label",
    defaultMessage: "+ Add another website",
  },
  websiteLimitLabel: {
    id: "funding-application: website limit label",
    defaultMessage: "Do you have any additional websites that you sell from?",
  },
  websiteLimitHelperText: {
    id: "funding-application: website limit helper text",
    defaultMessage: "We'll capture these later in the process",
  },
  invalidWebsiteUrl: { id: "funding-application: invalid website url", defaultMessage: "Please enter a valid URL" },
  additionalWebsiteLabelDefinition: {
    id: "funding-application: website additional entry label",
    defaultMessage: "Additional website {number}",
  },
  phoneNumberInvalid: {
    id: "funding-application: contact details phone number invalid",
    defaultMessage: "Please enter a valid phone number",
  },
});
